enum HotelNotifications {
    COMPETITOR_RATE_CHANGE = 'CompetitorRateChange',
    HOTEL_SOLD_OUT = 'SoldOut',
}

export default HotelNotifications;
